import React from "react";
import PropTypes from "prop-types";
import Markdown from "markdown-to-jsx";

import PageSection from "../PageSection";
import PageHeader from "./PageHeader";
import PageFooter from "./PageFooter";
import AppContext from "../AppContext";

class Page extends React.Component {
    render() {
        return (
            <AppContext.Consumer>
                {context => {
                    const { authenticated } = context.state;
                    return (
                        <React.Fragment>
                            <PageHeader
                                title={this.props.title}
                                subtitle={this.props.subtitle}
                                authenticated={authenticated}
                            />
                            <PageSection sectionName="main-content">
                                <Markdown className="md-content">
                                    {this.props.content}
                                </Markdown>
                            </PageSection>
                            <PageFooter />
                        </React.Fragment>
                    );
                }}
            </AppContext.Consumer>
        );
    }
}

Page.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    content: PropTypes.string
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/landingPage/Page.jsx